import { render } from "./modalDeletingRequest.vue?vue&type=template&id=1ce4c170"
import script from "./modalDeletingRequest.vue?vue&type=script&lang=js"
export * from "./modalDeletingRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__